<app-spinner></app-spinner>
<div class="sideNav">
  <app-nav-bar
    [menuItems]="menuItems"
    [agentName]="agentName"
    [user]="user"
    [contentClass]="'.contentBody'"
    [menuId]="menuId"
    (openDrawerEvent)="openDrawerHelper($event)"
    (userProfileClickEvent)="userProfileClick($event)"
    (logoutEvent)="logout()"
  >
  </app-nav-bar>
  <div class="contentBody">
    <!-- eslint-disable-next-line custom-rules/no-deprecated-message-bars -->
    <app-stacked-long-message-bar-v2 [messages]="messages" (messageClosedEvent)="messageClosed($event)"></app-stacked-long-message-bar-v2>
    <app-global-search-bar></app-global-search-bar>
    <app-recent-confirmation-codes></app-recent-confirmation-codes>
    <div class="content-outlet">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
